import { z } from 'zod';

// ── String primitives ──────────────────────────────────────────────────────
const baseString = z.string().trim();

// ── Number primitives ──────────────────────────────────────────────────────
const baseInt = z.number().int();
const basePositiveInt = baseInt.min(1);
const baseNonNegativeInt = baseInt.min(0);

export { baseString, baseInt, basePositiveInt, baseNonNegativeInt };
